module.exports = __webpack_public_path__ + "img/centered-logo-nav-ford.9fe17b13.png";